import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createUser } from "services/users";
import { useToast } from "components/Toast";

const AdminUserCreate: React.FC = () => {
  const [name, setName] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("user");
  const navigate = useNavigate();
  const toast = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await createUser({
        firstname,
        lastname,
        email,
        role,
        password: password || undefined,
      });
      navigate("/admin/users");
    } catch (err) {
      console.error(err);
      toast.showError("Failed to create user");
    }
  };

  return (
    <div className="p-4">
      <h2 className="mb-4 text-xl font-semibold">Create User</h2>
      <form onSubmit={handleSubmit} className="max-w-md space-y-4">
        <div className="grid grid-cols-2 gap-2">
          <div>
            <label className="block">First name</label>
            <input
              value={firstname}
              onChange={(e) => setFirstname(e.target.value)}
              className="input"
            />
          </div>
          <div>
            <label className="block">Last name</label>
            <input
              value={lastname}
              onChange={(e) => setLastname(e.target.value)}
              className="input"
            />
          </div>
        </div>
        <div>
          <label className="block">Email</label>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input"
          />
        </div>
        <div>
          <label className="block">Role</label>
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            className="input"
          >
            <option value="user">User</option>
            <option value="admin">Admin</option>
          </select>
        </div>
        <div>
          <label className="block">Password (optional)</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input"
          />
        </div>
        <div>
          <button className="btn btn-primary" type="submit">
            Create
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminUserCreate;
